import { Box } from "@mui/material";
import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function WebOnboardingButton({
	url,
	title = "Start",
	handleClick = () => {},
}) {
	const navigate = useNavigate();
	const location = useLocation();
	const publicUrl = process.env.PUBLIC_URL;

	const handleProceed = () => {
		handleClick();
		if (url) return navigate(`${publicUrl}${url}${location?.search || ""}`);
	};

	return (
		<React.Fragment>
            <button
                style={{
                    cursor: "pointer",
                    display: "inline-block",
                    width: "180px",
                    height: "45px",
                    backgroundColor: "#0e9595", // backgroundColor: "#0099ff", // 0e9595
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    borderBottom: "2px solid #0e9595", // borderBottom: "2px solid hsl(204,100%,37.5%)", // 0e9595
                    textDecoration: "none",
                    boxSizing: "border-box",
                    paddingTop: "3px",
                    textAlign: "center",
                    "&:hover": {
                        backgroundColor: "none",
                        cursor: "pointer",
                    },
                }}
                onClick={handleProceed}
            >
                <Box component="span"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "2em",
                        color: "white",
                        textAlign: "center",
                    }}
                >{title}</Box>
            </button>
		</React.Fragment>
	);
}